<main class="course container" id="curso">
  <div class="banner" id="banner" role="banner">
    <img src="/assets/comprimidas/{{ eixo.id }}/{{ curso.imagem }}" alt="{{ curso.nome }}" class="banner" />
    <h1 class="title text-center floating-text">{{ curso.nome }}</h1>
  </div>

  <section aria-label="informacoesCurso" class="course-content">
    <section class="course-item">
      <h2 class="subtitle">Perfil profissional de conclusão</h2>
      <ul class="paragraph" [innerHTML]="perfilProfissional | format"></ul>
    </section>
    <!--HU036-->
    <section class="course-item">
      <h2 class="subtitle" tabindex="0">Eixo tecnológico</h2>
      <a *ngIf="eixo" routerLink="/eixo-tecnologico" [queryParams]="{ id: eixo.id }" class="link item-link">
        {{ eixo.nome }}</a>
      <h2 class="subtitle area-title" tabindex="0">Área tecnológica</h2>
      <ng-container *ngIf="areasTecnologicas && areasTecnologicas.length > 0; else semArea">
        <!-- <a [routerLink]="['/eixo-tecnologico']" [queryParams]="{ id: curso.eixoTecnologicoId }"
          fragment="{{ areaTecnologica.id }}" class="link item-link">{{ areaTecnologica.nome }}</a> -->
        <div *ngFor="let area of areasTecnologicas">
          <a [routerLink]="['/cursos/area']"
            [queryParams]="{ areatecnologica: area.id, eixo: eixo.id, curso: curso.id }" class="link item-link">
            {{ area.nome }}</a>
        </div>
      </ng-container>

      <ng-template #semArea>
        <a class="link item-link">O eixo tecnológico não possui divisão em áreas tecnológicas</a>
      </ng-template>
    </section>
    <!--HU036-->

    <button class="btn btn-md-curso btn-dark rounded-pill" (click)="displayAll = !displayAll" style="margin-left: auto">
      {{ !displayAll ? 'expandir todos' : 'retrair todos' }}
    </button>

    <section class="course-item">
      <div class="item-title cursor-pointer" [ngClass]="{ open: displayAll }" appDisplay>
        <button type="button" class="display-btn cursor-pointer">expandir carga horária</button>
        <h2 class="subtitle">Carga horária mínima</h2>
      </div>
      <div class="paragraph toggle" [innerHTML]="curso.cargaHoraria | format"></div>
    </section>
    <div class="course-item">
      <hr class="bg-color-grey" />
      <div class="item-title cursor-pointer" [ngClass]="{ open: displayAll }" appDisplay>
        <button type="button" class="display-btn cursor-pointer">expandir pré-requisitos</button>
        <h2 class="subtitle">Pré-requisitos para ingresso</h2>
      </div>
      <div class="paragraph toggle" [innerHTML]="curso.preRequisito | format"></div>
    </div>

    <section class="course-item">
      <hr class="bg-color-grey" />
      <div class="item-title cursor-pointer" [ngClass]="{ open: displayAll }" appDisplay>
        <button type="button" class="display-btn cursor-pointer">
          expandir legislação profissional
        </button>
        <h2 class="subtitle">Legislação profissional</h2>
      </div>
      <div class="paragraph toggle" *ngIf="legislacoes; else legisMsg">
        <div class="legislacao-container" *ngFor="let legislacao of legislacoes">
          <a href="{{ legislacao.legislacaoCnct.link }}" target="_blank" rel="noreferrer"
            class="negrito link link__legislacao custom-link">{{ legislacao.legislacaoCnct.nome }}</a>
          <p class="text-justify">
            {{ legislacao.legislacaoCnct.descricao }}
          </p>
        </div>
      </div>
      <ng-template #legisMsg>
        <div>
          <p class="text-justify paragraph">Profissão não regulamentada.</p>
        </div>
      </ng-template>
    </section>

    <ul class="course-item">
      <hr class="bg-color-grey" />
      <div class="item-title cursor-pointer" [ngClass]="{ open: displayAll }" appDisplay>
        <button type="button" class="display-btn cursor-pointer">
          expandir itinerários formativos
        </button>
        <h2 class="subtitle">Itinerários formativos</h2>
        <span class="tooltip" role="tooltip">
          <p class="tooltip-text">
            São outras formações possíveis dentro da mesma área de atuação, mas em diferentes níveis
            de ensino. No caso dos cursos técnicos, podem ser certificações intermediárias de
            qualificação profissional, especializações técnicas ou cursos de graduação.
          </p>
        </span>
      </div>
      <div class="paragraph toggle" [innerHTML]="itinerarios | format"></div>
    </ul>

    <div class="course-item">
      <hr class="bg-color-grey" />
      <div class="item-title cursor-pointer" [ngClass]="{ open: displayAll }" appDisplay>
        <button type="button" class="display-btn cursor-pointer">expandir campos de atuação</button>
        <h2 class="subtitle">Campo de atuação</h2>
      </div>
      <div class="paragraph toggle" [innerHTML]="campoAtuacao | format"></div>
    </div>
    <div class="course-item cursor-pointer">
      <hr class="bg-color-grey" />
      <div class="item-title" [ngClass]="{ open: displayAll }" appDisplay>
        <button type="button" class="display-btn cursor-pointer">expandir Ocupações associadas</button>
        <h2 class="subtitle">Ocupações CBO associadas</h2>
        <span class="tooltip">
          <p class="tooltip-text">
            São as ocupações do mercado de trabalho, registradas na Classificação Brasileira de
            Ocupações (CBO), que tipicamente podem ser ocupadas pelos egressos de cada curso.
          </p>
        </span>
      </div>
      <ng-container *ngIf="ocupacoesCbo; else cbo">
        <div class="paragraph toggle" [innerHTML]="ocupacoesCbo | format"></div>
      </ng-container>

      <ng-template #cbo>
        <p class="text-justify paragraph toggle">Ocupação ainda não classificada.</p>
      </ng-template>
    </div>
    <div class="course-item cursor-pointer">
      <hr class="bg-color-grey" />
      <span class="item-title" [ngClass]="{ open: displayAll }" appDisplay>
        <button type="button" class="display-btn cursor-pointer">expandir infraestrutura mínima</button>
        <h2 class="subtitle">Infraestrutura mínima</h2>
      </span>
      <div class="paragraph toggle" [innerHTML]="infraestruturaMinima | format"></div>
    </div>
    <div class="course-item" *ngIf="mudaramNome">
      <hr class="bg-color-grey" />
      <div class="item-title cursor-pointer" [ngClass]="{ open: displayAll }" appDisplay>
        <button type="button" class="display-btn cursor-pointer">
          expandir nomenclaturas anteriores
        </button>
        <h2 class="subtitle">Nomenclaturas anteriores</h2>
        <span class="tooltip">
          <p class="tooltip-text">Denominações deste curso em edições anteriores do Catálogo.</p>
        </span>
      </div>
      <div class="paragraph toggle">
        <ul class="course-item">
          <li *ngFor="let curso of mudaramNome">
            {{ curso.nome }}
          </li>
        </ul>
      </div>
    </div>

    <div class="course-item">
      <hr class="bg-color-grey" />
      <div class="item-title cursor-pointer" [ngClass]="{ open: displayAll }" appDisplay>
        <button type="button" class="display-btn cursor-pointer">
          Expandir instituicões ofertantes
        </button>
        <h2 class="subtitle" tabindex="0">Instituições ofertantes</h2>
      </div>
      <p class="paragraph toggle">{{ mensagens }}
        <a *ngIf="totalInstituicoes > 0" routerLink="/cursos/instituicoes-ensino"
          [queryParams]="{ nomeCurso: curso.nome }" class="link item-link">clicando aqui</a>
      </p>
    </div>
  </section>
</main>